import { createServiceClient } from "../../shared/welda/services/axiosClient";

const api = createServiceClient("/users/client/");

const registerClient = async (formData) =>
  await api.post("/register", formData);

const loginClient = async (formData) => await api.post("/login", formData);

const updateClientAccount = async (formData) =>
  await api.post("/update-account", formData);

const updateClientProfile = async (formData) =>
  await api.post("/update-profile", formData);

const verifyClientEmail = async (token) =>
  await api.post("/verify-email", { token });

const verifyOrganizationMember = async (token) =>
  await api.post("/verify-organization-member", { token });

const requestClientPasswordReset = async (formData) =>
  await api.post("/reset-password-request", formData);

const requestClientEmailVerification = async (formData) =>
  await api.post("/verify-email-request", formData);

const resetClientPassword = async (formData) =>
  await api.post("/reset-password", formData);

const logoutClient = async () => await api.post("/logout");

const checkMe = async () => await api.get("/checkMe");

const clientServices = {
  registerClient,
  loginClient,
  updateClientAccount,
  updateClientProfile,
  verifyClientEmail,
  verifyOrganizationMember,
  requestClientPasswordReset,
  requestClientEmailVerification,
  resetClientPassword,
  logoutClient,
  checkMe,
};

export default clientServices;
